import { render } from "./RelationSVMCard.vue?vue&type=template&id=164fd0a9"
import script from "./RelationSVMCard.vue?vue&type=script&lang=js"
export * from "./RelationSVMCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__